import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1020e4d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-table-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GridRowCell = _resolveComponent("GridRowCell")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cellDatas, (item) => {
      return (_openBlock(), _createBlock(_component_GridRowCell, {
        key: item.initials,
        fieldId: _ctx.rowData.fieldId,
        fieldName: _ctx.rowData.fieldName,
        cellData: item,
        photoRow: _ctx.photoRow,
        fieldFriendlyName: _ctx.rowData.cells[0].value
      }, null, 8, ["fieldId", "fieldName", "cellData", "photoRow", "fieldFriendlyName"]))
    }), 128))
  ]))
}